module.exports = __webpack_public_path__ + "img/home-zyjz.48f57032.png";